import { Navigate, useParams } from 'react-router-dom';
import { Breadcrumbs } from '@aeg-presents/components/Breadcrumbs';
import { Button } from '@aeg-presents/components/Button';
import { DropdownButton } from '@aeg-presents/components/DropdownButton';
import { PageHeader } from '@aeg-presents/components/PageHeader';
import { Tabs, type TabItem } from '@aeg-presents/components/Tabs';
import { RouterLink } from '../../components/RouterLink';
import { TicketSalesGrid } from './TicketSalesGrid/TicketSalesGrid';
import { getTicketSalesTourById, ticketSalesMockData } from '../../data/ticketSalesMock';
import { Tour } from '../../types/tour';
import { TourDetailsPageContainer, TourDetailsTabContent } from './TourDetailsPage.styled';

enum TourActionsMenuOption {
  Action = 'Action',
}

const tourActionOptions = [{ label: 'Action', value: TourActionsMenuOption.Action }];

const TOUR_HEADER_NAME_COL_SIZE = 2;
const TOUR_HEADER_FIELDS_COL_SIZE = 7;
const TOUR_HEADER_ACTIONS_COL_SIZE = 3;

function mapTourToFields(tour: Tour) {
  return [
    { title: 'Headliner', value: tour.headliner },
    { title: 'Co-Headliners', value: tour.coHeadliners },
    { title: 'Company', value: tour.company },
    { title: 'Multi-Leg Tour', value: tour.multiLegTour },
    { title: 'Buyer', value: tour.buyer },
    { title: 'Operator', value: tour.operator },
  ];
}

export function TourDetailsPage() {
  const { id } = useParams<{ id: string }>();
  const tour = id ? getTicketSalesTourById(id) : undefined;

  if (!tour) {
    return <Navigate to={`/tours/${ticketSalesMockData.id}`} replace />;
  }

  const tabs: TabItem[] = [
    {
      id: 'Ticketing',
      label: 'Ticketing',
      visible: true,
      disabled: false,
      content: (
        <TourDetailsTabContent>
          <TicketSalesGrid venues={tour.venues} />
        </TourDetailsTabContent>
      ),
    },
  ];

  const handleTourAction = (_value: TourActionsMenuOption) => {
    // Placeholder until tour action flows are wired.
  };

  return (
    <TourDetailsPageContainer data-testid="tour-details">
      <Breadcrumbs
        items={[
          { text: 'Tours', href: '/tours' },
          { text: tour.name, href: `/tours/${tour.id}` },
        ]}
        LinkComponent={RouterLink}
      />
      <PageHeader
        headerText={tour.name}
        fields={mapTourToFields(tour)}
        showActions
        nameColSize={TOUR_HEADER_NAME_COL_SIZE}
        fieldsColSize={TOUR_HEADER_FIELDS_COL_SIZE}
        actionsColSize={TOUR_HEADER_ACTIONS_COL_SIZE}
        actions={
          <>
            <DropdownButton
              label="Actions"
              dropdownOptions={tourActionOptions}
              onSelect={handleTourAction}
              dataTestID="tour-header-actions"
            />
            <Button variant="contained" color="primary" dataTestID="tour-header-save">
              Save
            </Button>
          </>
        }
      />
      <Tabs tabs={tabs} idPrefix="tour-details" />
    </TourDetailsPageContainer>
  );
}
